import React from 'react';
import { shape, arrayOf, string } from 'prop-types';
import ContactCardPanel from '../contact-card-panel';

const PracticalInformation = (props) => (
  <div className="practical-information">
    <div className="practical-information__general-text">
      {props.Preamble && (
        <div dangerouslySetInnerHTML={{ __html: props.Preamble }} />
      )}
    </div>
    {props.Facilities?.length > 0 && (
      <ul className="practical-information__list">
        {props.Facilities?.map((item, index) => (
          <li key={`${index}--${item.Title}`}>
            <ContactCardPanel
              subheading={true}
              hasH3={true}
              contactCardHeading={item.Title}
              isLast={index === props.Facilities.length - 1}
            >
              <div dangerouslySetInnerHTML={{ __html: item.Description }} />
            </ContactCardPanel>
          </li>
        ))}
      </ul>
    )}
  </div>
);

PracticalInformation.propTypes = {
  Preamble: string,
  Facilities: arrayOf(
    shape({
      Title: string,
      Description: string,
    })
  ),
};

export default PracticalInformation;
